import templateUrl from './shiftSlotsComponent.html';

export default {
  templateUrl,
  bindings: {
    event: '<',
    slotsShown: '=',
  },
  controllerAs: 'ctrl',
  controller: class {
    constructor(Authentication) {
      'ngInject';

      Object.assign(this, { Authentication });
    }

    $onInit() {
      // bind out
      this.slotsShown = this.shouldShowSlotsCount() || this.shouldShowUnassignedSlotsCount();
    }

    shouldShowSlotsCount() {
      return this.event.showAvailableShiftIcon && this.user.isManager;
    }

    shouldShowUnassignedSlotsCount() {
      return (
        !this.event.user &&
        !this.event.available &&
        !this.event.offer &&
        this.event.slots &&
        this.user.isManager
      );
    }

    shouldShowAvailableShiftIcon() {
      return (
        this.event.showAvailableShiftIcon &&
        !this.event.myApplication &&
        (!this.user.isManager || !this.event.applications?.length)
      );
    }

    get user() {
      return this.Authentication.user;
    }
  },
};
